import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function handleDownloadExcel({ filename, tableHeader, tableBody }) {
  const data = [tableHeader, ...tableBody]; // une encabezado + cuerpo

  const ws = XLSX.utils.aoa_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Hoja1");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([excelBuffer]), `${filename}.xlsx`);
}